import { render, staticRenderFns } from "./KnittedTrimsReport.vue?vue&type=template&id=2a45f69e"
import script from "./KnittedTrimsReport.vue?vue&type=script&lang=js"
export * from "./KnittedTrimsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports